<template>
  <breeze-authenticated-layout>
    <template #header>
      <div class="flex">
        <inertia-link
          :href="
            registration.status == 1
              ? route('staff.registrations.pending')
              : route('staff.registrations.all')
          "
          class="flex-1 text-blue-900 hover:text-blue-800"
        >
          <h2 class="font-semibold text-xl leading-tight flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="
                mr-3
                h-4
                w-4
                fill-current
                text-blue-900
                hover:text-blue-600
              "
              viewBox="0 0 20 20"
            >
              <polygon
                points="3.828 9 9.899 2.929 8.485 1.515 0 10 .707 10.707 8.485 18.485 9.899 17.071 3.828 11 20 11 20 9 3.828 9"
              />
            </svg>
            คำขอโดเมน {{ registration.domain }}
          </h2>
        </inertia-link>
      </div>
    </template>

    <div class="py-12 max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
        <div
          v-if="registration.status == 1"
          class="p-4 bg-blue-900 text-right"
        >
          <button
            class="
              px-4
              py-2
              bg-yellow-500
              border border-transparent
              rounded-md
              text-lg text-blue-900
              tracking-widest
              hover:bg-yellow-600
              active:bg-yellow-700
              focus:outline-none
              focus:border-yellow-700
              focus:shadow-outline-white
              transition
              ease-in-out
              duration-150
            "
            :class="{
              'opacity-50': form.processing,
            }"
            :disabled="form.processing"
            @click="confirmApprove"
          >
            อนุมัติคำขอ
          </button>
          <button
            class="
              px-4
              py-2
              bg-white
              ml-2
              border border-transparent
              rounded-md
              text-lg text-blue-900
              tracking-widest
              hover:bg-gray-100
              active:bg-gray-200
              focus:outline-none
              focus:border-gray-100
              focus:shadow-outline-white
              transition
              ease-in-out
              duration-150
            "
            :class="{
              'opacity-50': form.processing,
            }"
            :disabled="form.processing"
            @click="confirmReject"
          >
            ปฏิเสธคำขอ
          </button>
        </div>
        <div class="p-6 border-b border-gray-200">
          <registration-data
            :registration="registration"
            :statuses="statuses"
          />
        </div>
      </div>
    </div>

    <breeze-dialog-modal
      :show="confirmApproveModal"
      @close="closeComfirmApproveModal"
    >
      <template #title> ยืนยันการอนุมัติ</template>

      <template #content>
        <p>
          เมื่อกดอนุมัติแล้ว ระบบจะส่งอีเมลจัดการเว็บไซต์ไปให้ลูกค้าที่
          {{ registration.email }} ยืนยันการอนุมัติหรือไม่
        </p>
      </template>

      <template #footer>
        <breeze-secondary-button @click="closeComfirmApproveModal">
          ปิดหน้าต่าง
        </breeze-secondary-button>

        <breeze-button
          class="ml-2"
          @click="approve"
          :class="{
            'opacity-25': form.processing,
          }"
          :disabled="form.processing"
        >
          ใช่ ฉันยืนยัน
        </breeze-button>
      </template>
    </breeze-dialog-modal>

    <breeze-dialog-modal
      :show="confirmRejectModal"
      @close="closeComfirmRejectModal"
    >
      <template #title> ยืนยันการปฏิเสธ</template>

      <template #content>
        <div>
          <breeze-label for="owner_branch_name" value="เลือกเหตุผลการปฏิเสธ*" />
          <select
            v-model="formReject.remark"
            class="
              w-full
              mt-1
              border-gray-300
              focus:border-indigo-300
              focus:ring focus:ring-indigo-200 focus:ring-opacity-50
              rounded-md
              shadow-sm
            "
          >
            <option :value="null" disabled>-- กรุณาเลือก --</option>
            <option
              v-for="(reason, index) in reasons"
              :key="`rea-${index}`"
              :value="reason"
            >
              {{ reason }}
            </option>
          </select>
          <breeze-input-error
            :message="formReject.errors.remark"
            class="mt-2"
          />
        </div>
        <p class="mt-4">
          เมื่อกดอนุมัติแล้ว ระบบจะส่งอีเมลแจ้งลูกค้าว่าคำขอได้ถูกปฏิเสธไปที่
          {{ registration.email }}
          <span class="text-red-700 underline">ยืนยันการปฏิเสธหรือไม่</span>
        </p>
      </template>

      <template #footer>
        <breeze-secondary-button @click="closeComfirmRejectModal">
          ปิดหน้าต่าง
        </breeze-secondary-button>

        <breeze-button
          class="ml-2"
          @click="reject"
          :class="{
            'opacity-25': formReject.processing,
          }"
          :disabled="formReject.processing"
        >
          ใช่ ฉันยืนยัน
        </breeze-button>
      </template>
    </breeze-dialog-modal>
  </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import RegistrationData from "./RegistrationData";
import BreezeButton from "@/Components/Button";
import BreezeSecondaryButton from "@/Components/SecondaryButton";
import BreezeDialogModal from "@/Components/DialogModal";
import BreezeLabel from "@/Components/Label";
import BreezeInputError from "@/Components/InputError";

export default {
  props: ["registration", "statuses"],
  components: {
    BreezeAuthenticatedLayout,
    RegistrationData,
    BreezeButton,
    BreezeDialogModal,
    BreezeSecondaryButton,
    BreezeLabel,
    BreezeInputError,
  },
  data() {
    return {
      formReject: this.$inertia.form({
        remark: null,
      }),
      form: this.$inertia.form(),
      confirmApproveModal: false,
      confirmRejectModal: false,
      reasons: [
        "ชื่อโดเมนที่ท่านขอจดทะเบียนไม่เป็นไปตามนโยบายการจดทะเบียนชื่อโดเมน .co.th",
        "ไม่พบหมายเลขทะเบียนนิติบุคคลในฐานข้อมูลของกรมพัฒนาธุรกิจการค้า (DBD)",
        "ไม่พบหมายเลขทะเบียนพาณิชย์ในฐานข้อมูลผู้จดทะเบียน DBD Registered",
      ],
    };
  },
  methods: {
    confirmApprove() {
      this.confirmApproveModal = true;
    },
    approve() {
      this.form.put(route("staff.registrations.approve", this.registration), {
        onFinish: () => {
          this.closeComfirmApproveModal();
        },
      });
    },
    closeComfirmApproveModal() {
      this.confirmApproveModal = false;
    },
    confirmReject() {
      this.confirmRejectModal = true;
    },
    reject() {
      this.formReject.put(
        route("staff.registrations.reject", this.registration),
        {
          onSuccess: () => {
            this.closeComfirmRejectModal();
          },
        }
      );
    },
    closeComfirmRejectModal() {
      this.confirmRejectModal = false;
    },
  },
};
</script>
